export default {
  title: 'Informations de paiement vérifiées',
  description: 'Vos informations de paiement ont été vérifiées avec succès.',
};
